import React from "react";
import { Link } from "react-router-dom";
import { Globe, Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { BRANDS } from "@/i18n/translations";

export default function Footer() {
  const { t, loc } = useLang();
  return (
    <footer className="bg-ink text-cream" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-serif text-4xl md:text-5xl leading-none">Tan Putra Tama</div>
            <div className="text-[11px] uppercase tracking-[0.32em] text-clara-accent mt-2">{t("footer.tagline")} · {t("common.since")}</div>
            <p className="text-cream/60 mt-6 max-w-sm leading-relaxed text-sm">
              {loc({ id: "Produsen bahan kue, cokelat, dan cokelat bubuk tepercaya di Indonesia sejak 1976.", en: "Trusted Indonesian manufacturer of baking ingredients, chocolate and cocoa powder since 1976." })}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-widest text-cream/40 mb-5">{t("nav.brands")}</div>
            <ul className="space-y-3">
              {BRANDS.map((b) => (
                <li key={b.slug}>
                  <Link to={`/brands/${b.slug}`} data-testid={`footer-brand-${b.slug}`} className="group inline-flex items-center gap-2 text-cream/80 hover:text-cream transition-colors">
                    <span className="h-1.5 w-1.5 rounded-full" style={{ background: b.accent }} />
                    {b.name}
                    <ArrowUpRight size={13} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-widest text-cream/40 mb-5">{t("contact.reach")}</div>
            <ul className="space-y-4 text-sm text-cream/80">
              <li className="flex gap-3"><MapPin size={17} className="text-clara-accent shrink-0 mt-0.5" /> Jl. Raya Narogong, Pangkalan II, Cikiwul – Bantargebang, Bekasi, Jawa Barat 17152</li>
              <li className="flex gap-3"><Phone size={17} className="text-clara-accent shrink-0" /> +62 21 8261 0031 · +62 21 8251 113</li>
              <li className="flex gap-3"><Mail size={17} className="text-clara-accent shrink-0" /> marketing@tanputratama.co.id</li>
              <li className="flex gap-3"><Globe size={17} className="text-clara-accent shrink-0" /> <a href="https://www.claracocoa.co.id" target="_blank" rel="noreferrer" data-testid="footer-clara-web" className="hover:text-cream transition-colors">www.claracocoa.co.id</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream/40">
          <span>© {new Date().getFullYear()} PT Tan Putra Tama. {t("footer.rights")}</span>
          <div className="flex items-center gap-6">
            <span>Halal · BPOM · ISO 9001:2015 · SNI</span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-cream transition-colors">{t("footer.admin")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
